// actions/holidayActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllHolidays =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "HOLIDAY_REQUEST" });
      const { data } = await api.get("/holidays", { params });
      dispatch({ type: "GET_HOLIDAYS_SUCCESS", payload: data.holidays });
    } catch (err) {
      dispatch({ type: "HOLIDAY_FAIL", payload: err.response?.data?.message });
    }
  };

export const createHoliday = (holidayData) => async (dispatch) => {
  try {
    dispatch({ type: "HOLIDAY_REQUEST" });
    const { data } = await api.post("/holidays", holidayData);
    dispatch({ type: "CREATE_HOLIDAY_SUCCESS", payload: data.holiday });
  } catch (err) {
    dispatch({ type: "HOLIDAY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const updateHoliday = (id, holidayData) => async (dispatch) => {
  try {
    dispatch({ type: "HOLIDAY_REQUEST" });
    const { data } = await api.put(`/holidays/${id}`, holidayData);
    dispatch({ type: "UPDATE_HOLIDAY_SUCCESS", payload: data.holiday });
  } catch (err) {
    dispatch({ type: "HOLIDAY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const deleteHoliday = (id) => async (dispatch) => {
  try {
    dispatch({ type: "HOLIDAY_REQUEST" });
    await api.delete(`/holidays/${id}`);
    dispatch({ type: "DELETE_HOLIDAY_SUCCESS", payload: id });
  } catch (err) {
    dispatch({ type: "HOLIDAY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const sendHolidayNotification = (id) => async (dispatch) => {
  try {
    dispatch({ type: "HOLIDAY_REQUEST" });
    await api.post(`/holidays/${id}/notify`);
    dispatch({ type: "HOLIDAY_NOTIFY_SUCCESS", payload: id });
  } catch (err) {
    dispatch({ type: "HOLIDAY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const getHolidaysForSalary = (year, month) => async (dispatch) => {
  try {
    const { data } = await api.get("/holidays/salary-check", {
      params: { year, month },
    });
    dispatch({ type: "SALARY_HOLIDAYS_SUCCESS", payload: data });
    return data;
  } catch (err) {
    throw err;
  }
};
